/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/react-in-jsx-scope */
import { Provider } from 'react-redux';
import './App.css';
import Main from './components/Main/Main';
import Navbar from './components/Navbar';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
      <Navbar />
      <Main />
    </Provider>
  );
}

export default App;
